import { gql } from "@apollo/client";

export const SystemClientRegion = gql`
    query SystemClientRegion($id: ID!) {
        system(id: $id) {
            id
            systemType
            client {
                id
                region {
                    id
                    key
                }
            }
            installedBaseNode {
                id
                title
                isStarred
                nodeType {
                    id
                    key
                }
                access {
                    id
                    write
                    delete
                }
            }
        }
    }
`;
